import { MutationTree } from 'vuex';
import { UserState, StorageUserData, ParsedToken, StorageCustomerInfo } from './types';
import JwtDecode from 'jwt-decode';

interface MutationType {
    SET_USER: (state: UserState, data: StorageUserData) => void;
    CLEAR_USER: (state: UserState) => void;
    SET_CUSTOMER_INFO: (state: UserState, data: StorageCustomerInfo) => void;
    CLEAR_CUSTOMER_INFO: (state: UserState) => void;
    SHOW_WELCOME_NOTICE: (state: UserState) => void;
    CLOSE_WELCOME_NOTICE: (state: UserState) => void;
}

export const mutations: MutationTree<UserState> & MutationType = {
    SET_USER: (state: UserState, data: StorageUserData) => {
        const payload = JwtDecode<ParsedToken>(data.token);

        state.token = data.token;
        state.expireTime = payload.exp * 1000;
        state.email = payload.user_email;
        state.keepLogin = data.keepLogin;
    },
    CLEAR_USER: (state: UserState) => {
        state.token         = '';
        state.expireTime    = 0;
        state.email         = '';
        state.keepLogin     = false;
    },
    SET_CUSTOMER_INFO: (state: UserState, data: StorageCustomerInfo) => {
        state.customerInfo   = {
            customer_id: data.customer_id,
            customer_no: data.customer_no,
            company_no: data.company_no,
        }
    },
    CLEAR_CUSTOMER_INFO: (state: UserState) => {
        state.customerInfo = null
    },
    SHOW_WELCOME_NOTICE: (state: UserState) => {
        state.noticeClosed = false;
    },
    CLOSE_WELCOME_NOTICE: (state: UserState) => {
        state.noticeClosed = true;
    }
};

